import { render, staticRenderFns } from "./BuyerAccountBudgetDetails.vue?vue&type=template&id=78ef2c81&lang=true"
import script from "./BuyerAccountBudgetDetails.vue?vue&type=script&lang=js"
export * from "./BuyerAccountBudgetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports